import { render, staticRenderFns } from "./agentTransfer.vue?vue&type=template&id=bf806e26&scoped=true&"
import script from "./agentTransfer.vue?vue&type=script&lang=js&"
export * from "./agentTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf806e26",
  null
  
)

export default component.exports